import React from 'react';
import { connect } from 'react-redux';
import {getRaceDetails, selectEvent, syncFavorites, performSearch, switchRace} from '../actions/race';
import Loading from './Loading';
import SearchIcon from '../icons/search';
import FilterIcon from '../icons/filter';
import FavoriteIcon from '../icons/favorite';

class MobileRaceHome extends React.Component {

  constructor(props, context) {
    super(props, context);
  }

  state = {

  };

  componentDidMount() {

    this.props.syncFavorites(this.props.match.params.raceId);
    if (this.props.match.params.raceId) {
      this.props.getRaceDetails(this.props.match.params.raceId);
    }
  }

  componentDidUpdate(oldProps){

    if (this.props.match.params.raceId !== oldProps.match.params.raceId) {
      this.props.switchRace(this.props.match.params.raceId);
      this.props.syncFavorites(this.props.match.params.raceId);
    }
  }



  render() {

    const {raceDetail} = this.props;

    if (!raceDetail || !raceDetail.name) return (<Loading />);

    return (
      <div>
        <div className="welcome">
          <h2><strong>{raceDetail.name}</strong></h2>
          <h2>{raceDetail.event_date}</h2>
        </div>
        <div className="nav">
          <ul>
            <li className="menuitem link-search" data-page="search"><a href={`#/race/${raceDetail.race_id}/search`}>
              <SearchIcon />
              <span>Athlete Search</span></a></li>
            <li className="menuitem link-filter" data-page="filter"><a href={`#/race/${raceDetail.race_id}/results`}>
              <FilterIcon />
              <span>Filter Results</span></a></li>
            <li className="menuitem link-favorites" data-page="favorites"><a href={`#/race/${raceDetail.race_id}/favorites`}>
              <FavoriteIcon />
              <span>Favorites</span></a></li>
          </ul>
        </div>
      </div>
    )

  }
}

function mapStateToProps(state) {
  return {
    raceDetail: state.rr360.raceDetail,
    eventId: state.rr360.eventId
  };
}


export default connect(mapStateToProps, {getRaceDetails, selectEvent, syncFavorites, performSearch, switchRace})(MobileRaceHome);



// WEBPACK FOOTER //
// ./src/components/MobileRaceHome.js